import { render } from "./OptDonutChart.vue?vue&type=template&id=17547380"
import script from "./OptDonutChart.vue?vue&type=script&lang=js"
export * from "./OptDonutChart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__